import { useId } from 'react';
import { CuratedMetaPublishProgress, normalizeCuratedMetaPublishProgress } from '../CuratedMetaPublishProgress.jsx';
import { CampaignModal } from './CampaignOverlays.jsx';

const BACKGROUND_NOTICE_ID = 'bl-paused-creation-background-note';

export const pausedCreationProgressModalCopy = Object.freeze({
  backgroundHeading: 'Closing this window does not stop creation.',
  background: 'Creation continues in the background. The campaign page shows its current status.',
  paused: 'Everything is created paused with no spend until a company owner or admin activates the campaign.',
  close: 'Close',
  openCampaign: 'Open campaign page',
  closedFeedback: 'Creation continues in the background. Open the campaign page to check its status.',
});

export function PausedCreationProgressModal({
  progress,
  companyId = '',
  campaignId = '',
  onClose,
  onOpenCampaign,
  returnFocus,
}) {
  const generatedId = useId().replaceAll(':', '');
  const titleId = `bl-paused-creation-progress-${generatedId}-title`;
  const state = normalizeCuratedMetaPublishProgress(progress).state;
  return (
    <CampaignModal
      className="bl-campaign-progress-modal"
      labelledBy={titleId}
      descriptionId={BACKGROUND_NOTICE_ID}
      onClose={onClose}
      returnFocus={returnFocus}
      footer={<>
        <button type="button" data-campaign-safe-focus onClick={onClose}>
          {pausedCreationProgressModalCopy.close}
        </button>
        <button type="button" className="is-primary" onClick={onOpenCampaign}>
          {pausedCreationProgressModalCopy.openCampaign}
        </button>
      </>}
    >
      {/* The progress section renders no heading at all while not_started (it
          renders nothing), so the dialog would otherwise be unlabelled for that
          instant. Once staged or live progress exists, that section's own h2
          is the dialog's only heading and carries this same id. */}
      {state === 'not_started' && (
        <h2 id={titleId} className="bl-visually-hidden">Meta creation</h2>
      )}
      <CuratedMetaPublishProgress
        progress={progress}
        companyId={companyId}
        campaignId={campaignId}
        titleId={titleId}
        dismissible={false}
      />
      <div className="bl-campaign-action-notice" id={BACKGROUND_NOTICE_ID} role="note">
        <strong>{pausedCreationProgressModalCopy.backgroundHeading}</strong>
        {' '}{pausedCreationProgressModalCopy.background}{' '}
        {pausedCreationProgressModalCopy.paused}
      </div>
    </CampaignModal>
  );
}
